import NewPaymentMethodPopUp from './NewPaymentMethodPopUp';

export default NewPaymentMethodPopUp;